import React from "react";

import { Box, Theme, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { graphql } from "@/gql";
import { Maybe } from "@/gql/graphql";
import { FragmentType } from "@/utils/type";

const useStyles = makeStyles()((theme: Theme) => ({
  mr5: {
    marginRight: theme.spacing(5),
  },
}));

type MacronutrientsProps = {
  data: FragmentType<typeof macronutrientsFragment>;
};

const macronutrientsFragment = graphql(`
  fragment TemplateItemMacronutrients on MealPlanTemplate {
    macronutrientsCarbohydratePercent
    macronutrientsProteinPercent
    macronutrientsFatPercent
  }
`);

const Macronutrients: React.FC<MacronutrientsProps> = ({ data }) => {
  const { classes } = useStyles();

  function renderMacronutrient(initial: string, amount?: Maybe<number>) {
    return (
      <Typography variant="subtitle1" color="textPrimary">
        {initial}:&nbsp;
        <Typography component="span" color="textSecondary">
          {amount == null ? <>&mdash;</> : `${amount}%`}
        </Typography>
      </Typography>
    );
  }

  return (
    <Box display="flex" flexDirection="row" flexWrap="wrap">
      {renderMacronutrient("C", data.macronutrientsCarbohydratePercent)}
      <Box className={classes.mr5} display="inline" />
      {renderMacronutrient("P", data.macronutrientsProteinPercent)}
      <Box className={classes.mr5} display="inline" />
      {renderMacronutrient("F", data.macronutrientsFatPercent)}
    </Box>
  );
};

export default Macronutrients;
